import React from 'react';
import { Box, Heading, Body } from '@hover/blueprint';
import { StaticImage } from 'gatsby-plugin-image';
import IconQuote from '../../../assets/images/icon-quote.svg';

const HappyCustomers = () => (
  <Box d="block" mt={24}>
    <Heading
      size={{ base: 500, tablet: 600, desktop: 700 }}
      textAlign="center"
      style={{ marginBottom: 60 }}
    >
      Happy Customers
    </Heading>

    <Box maxW="6xl" w="100%" gap={{ base: 8, tablet: 20 }}>
      <Box justifyContent="center" alignItems="flex-start" position="relative">
        <StaticImage
          src="../../../assets/images/jonathan-baurer.jpeg"
          alt=""
          style={{ borderRadius: '50%', height: '120px', width: '120px' }}
        />
        <IconQuote
          style={{
            height: 57,
            width: 72,
            position: 'absolute',
            zIndex: -1,
            top: -16,
            right: -36,
          }}
          alt=""
        />
      </Box>
      <Box d="block">
        <Heading size={500} fontWeight="400">
          With Estimate To Order, our team doesn&apos;t waste time on creating
          material lists. Instead, we can focus on what&apos;s really important;
          our customer&apos;s experience. We are now more efficient as we can
          eliminate all manual work and improve the accuracy of our material
          order lists. We just take a few photos, simply select our products and
          move forward with confidence.
        </Heading>
        <Body size={600}>
          Jonathan Baurer, Director of Digital Strategy, Endeavor Exteriors
        </Body>
      </Box>
    </Box>
  </Box>
);

export default HappyCustomers;
